export enum importStatus {
  DEFAULT = 'Import List',
  MAPPING = 'Mapping',
  UPLOADING = 'Uploading',
  IN_PROGRESS = 'In Progress',
  FAILED = 'Failed. Try again.',
}
